<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="container">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <section v-if="listData.length > 0">
                <div class="list_box1">
                    <!-- <h4>原材成本汇总表</h4> -->
                    <table border>
                        <thead>
                            <tr>
                                <th class="dept_name"></th>
                                <th>精粉用量</th>
                                <th>产成品</th>
                                <th>二口料</th>
                                <th>尾料</th>
                                <th>用电量</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="list_box">
                    <!-- <h4>原材成本汇总表</h4> -->
                    <table border>
                        <tbody class="table_body_box">
                            <template v-for="(item, index) in listData">
                                <tr :key="`cost_${index}`" :class="{tr_shallow: index % 2 === 0, tr_deep: index % 2 !== 0}">
                                    <td align="center" class="dept_name">
                                        {{ item.dept_name }}
                                    </td>
                                    <td align="center">
                                        {{ item.inventory }}
                                    </td>
                                    <td align="center">
                                        {{ item.finished_production }}
                                    </td>
                                    <td align="center">
                                        {{ item.scrap_production }}
                                    </td>
                                    <td align="center">
                                        {{ item.tailings_production }}
                                    </td>
                                    <td align="center">
                                        {{ item.electricity }}
                                    </td>
                                </tr>
                            </template>
                            <!-- <div class="border_div"></div> -->
                        </tbody>
                    </table>
                </div>
            </section>
            <div v-else class="no_data"></div>
        </div>
    </v-touch>
</template>

<script>
export default {
    data() {
        return {
            navData: {
                title: '生产日报表',
                leftText: '',
                rightText: '',
                leftArrow: true,
                leftCallBack: this.swiperright,
            },
            listData: [],
            date: '',
        };
    },
    created() {
        this.listData = JSON.parse(this.$route.params.tableData);
        this.date = this.$route.params.date;
    },
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/hljDailyProductionReport' });
        },
    },
};
</script>

<style lang="stylus" scoped>
.container
    width 100%
    height 100%
    section
        height 100%
        table
            height 100%
            border-collapse collapse
            border-color #E4E4E4;
        .list_box1
            width 100%
            margin 6rpx 6rpx 0 6rpx
            height 36rpx
            table
                width calc(100% - 12rpx)
                thead
                    background #FBEEEE
                    border-bottom 1px solid #bebebe
                    height: 38rpx
                    tr
                        font-size: 11rpx
                        height: 38rpx
                        line-height 36rpx
                .table_body_box
                    height calc(100% - 60rpx)
                    overflow-y scroll
                tr
                    width 100%
                    display flex
                    th
                        font-size 11rpx
                        font-weight 540
                        color #000
                    th, td
                        width 50%
                        border 1px solid #E4E4E4;
                .tr_shallow
                    background #ffffff
                .tr_deep
                    background #F9FAFD
                .dept_name
                    width: 60%
        .list_box
            width 100%
            margin 0 0 6rpx 6rpx
            height calc(100% - 125rpx)
            overflow: auto;
            table
                width calc(100% - 12rpx)
                .border_div
                    width 100%
                    height 1px
                    background #d0d0d0;
                tr
                    width 100%
                    display flex
                    height 36rpx
                    line-height 36rpx
                    font-size 12rpx
                    th
                        font-weight 540
                        color #000
                    th, td
                        width 50%
                        border 1px solid #E4E4E4;
                .tr_shallow
                    background #ffffff
                .tr_deep
                    background #F9FAFD
                .dept_name
                    width: 60%
                    font-size 12rpx
    .noData
        width: 100%
        margin-top: 50rpx

</style>
